import type { SelectHTMLAttributes } from "react";

import { cx } from "./cx";
import { CONTROL } from "./Input";

export function Select({ className, children, ...rest }: SelectHTMLAttributes<HTMLSelectElement>) {
  return (
    <select className={cx(CONTROL, "pr-8", className)} {...rest}>
      {children}
    </select>
  );
}
